import React from 'react'
import { IoIosCloseCircleOutline } from 'react-icons/io'


const PrivacyRejectedModal = ({
  onClose,
  accept,
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] backdrop-blur-md">
      <div className="bg-white dark:bg-dark rounded-lg shadow-lg w-full max-w-[400px] p-4 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <IoIosCloseCircleOutline className="h-5 w-5" />
        </button>

        <div className="flex flex-col items-center text-center p-5">

          <h2 className="text-xl font-bold mb-2 dark:text-white">
            Registration Failed
          </h2>
          <p className="text-gray-500 text-sm mb-6">
            We’re unable to proceed with your registration because you declined the privacy policy
          </p>

          <div className="flex flex-col gap-4 w-full">
            <button className="flex-1 py-3 text-sm rounded-full bg-yellowcolor text-black" onClick={() => {
              accept()
              onClose()
            }}>
              Accept Policy Now
            </button>

            <button
              className="flex-1 py-3 rounded-full border border-yellowcolor text-yellowcolor text-sm" onClick={() => {
                window.location.href = "/"
              }}>
              Exit to Homepage
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyRejectedModal